import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SignatureSessionService } from '../../services/signature-session.service';
import { LogService } from 'src/app/modules/shared/services/log.service';
import { CreateSignatureMessages } from '../../../shared/models/component-messages/create-signature-messages';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { ToastMessages } from '../../../shared/models/component-messages/toast-messages';

@Component({
  selector: 'app-create-signature',
  templateUrl: './create-signature.component.html',
  styleUrls: ['./create-signature.component.scss']
})
export class CreateSignatureComponent implements OnInit, OnDestroy {

  public createSignatureMessages = new CreateSignatureMessages();
  public toastMessages = new ToastMessages();
  public filesToUpload: Array<any> = [];
  public errorSize: string;
  public errorLength: string;
  public validationMessage = '';
  public noFileLoaded = true;

  constructor(private toastr: ToastrService, private signatureSession: SignatureSessionService, private LOG: LogService,
              private translate: TranslateService, private commonService: CommonService) {
  }

  public ngOnDestroy() {
    this.LOG.log('[CERTIFICATE DESTROY]');
  }

  public ngOnInit() {
    this.noFileLoaded = true;
    this.errorSize = '';
    this.filesToUpload.push({
      name: 'uploader.upload.create',
      limitSize: 1,
      required: true,
      type: 'signed'
    });
  }

  public getErrorSize(errorSize) {
    this.errorSize = errorSize;
  }

  public getErrorLength(errorLength) {
    this.errorLength = errorLength;
  }

  public disableButton(): boolean {
    return this.noFileLoaded;
  }

  public uploadFile(obj: any) {
    this.toastr.success(this.translate.instant(this.toastMessages.folder) + obj.file.name + this.translate.instant(this.toastMessages.load),
      this.translate.instant(this.toastMessages.successTitle));
    this.noFileLoaded = false;
    this.signatureSession.signatureRequestData.documentToSign = obj.file;
    this.signatureSession.signatureRequestData.fileType = this.commonService.getFileExtensionFromName(obj.file.name).toUpperCase();
  }
}
